var image_upload_default = {
  "container": "Yk51c",
  "disabled": "ybGvi",
  "imageInput": "ziLLt",
  "overlay": "UO7ue",
  "text": "bl3-k",
  "shown": "_12nOy",
  "hide": "JwxHZ",
  "spinner": "_4oh90",
  "spin": "eLEZp"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
